<template>
  <RouterLink
    class="lib-btn-menu"
    :to="to"
    :style="{ color: $vuetify.theme.currentTheme.text }"
  >
    <div class="btn-text">{{ text }}</div>
    <div class="btn-line-cont"><div class="btn-line"></div></div>
  </RouterLink>
</template>

<script>
export default {
  name: "LibBtnMenu",
  props: {
    text: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "/",
    },
  },
};
</script>
<style lang="scss" scoped>
.lib-btn-menu {
  font-size: 1.125rem;
  font-weight: 400;
  text-decoration: none;
  position: relative;
  &:hover {
    .btn-line-cont {
      opacity: 0.3;
    }
  }
}
.btn-line-cont {
  margin-top: 4px;
  opacity: 0;
  position: absolute;
  width: 100%;
  transition: 0.3s all;
}
.btn-line {
  height: 4px;
  background-color: var(--c-primary-blue);
  margin: auto;
  width: 82%;
}
.lib-btn-menu.router-link-exact-active {
  font-size: 1.375rem;
  font-weight: 600;
  .btn-line-cont {
    opacity: 1;
  }
}
</style>
